module.exports = __webpack_public_path__ + "img/hr-boiling-green-patch-mask.332f7e12.png";